/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const deleteUsers = /* GraphQL */ `
  mutation DeleteUsers($user_id: String!) {
    deleteUsers(user_id: $user_id) {
      client_id
      user_id
      first_name
      last_name
      email
      company_name
      country
      is_active
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const createUsers = /* GraphQL */ `
  mutation CreateUsers($createUsersInput: CreateUsersInput!) {
    createUsers(createUsersInput: $createUsersInput) {
      client_id
      user_id
      first_name
      last_name
      email
      company_name
      country
      is_active
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const updateUsers = /* GraphQL */ `
  mutation UpdateUsers($updateUsersInput: UpdateUsersInput!) {
    updateUsers(updateUsersInput: $updateUsersInput) {
      client_id
      user_id
      first_name
      last_name
      email
      company_name
      country
      is_active
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const deleteCustomerData = /* GraphQL */ `
  mutation DeleteCustomerData($customer_id: String!) {
    deleteCustomerData(customer_id: $customer_id) {
      customer_id
      name
      description
      account_email
      billing_email
      billing_details
      shipping_details
      time_zone
      invoice_prefix
      next_invoice
      tax_id
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const createCustomerData = /* GraphQL */ `
  mutation CreateCustomerData(
    $createCustomerDataInput: CreateCustomerDataInput!
  ) {
    createCustomerData(createCustomerDataInput: $createCustomerDataInput) {
      customer_id
      name
      description
      account_email
      billing_email
      billing_details
      shipping_details
      time_zone
      invoice_prefix
      next_invoice
      tax_id
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const updateCustomerData = /* GraphQL */ `
  mutation UpdateCustomerData(
    $updateCustomerDataInput: UpdateCustomerDataInput!
  ) {
    updateCustomerData(updateCustomerDataInput: $updateCustomerDataInput) {
      customer_id
      name
      description
      account_email
      billing_email
      billing_details
      shipping_details
      time_zone
      invoice_prefix
      next_invoice
      tax_id
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer($customer_id: String!) {
    deleteCustomer(customer_id: $customer_id) {
      client_id
      user_id
      name
      description
      account_email
      billing_email
      billing_details
      shipping_details
      time_zone
      invoice_prefix
      next_invoice
      tax_id
      inserted_dt
      updated_dt
      customer_id
      __typename
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer($createCustomerInput: CreateCustomerInput!) {
    createCustomer(createCustomerInput: $createCustomerInput) {
      client_id
      user_id
      name
      description
      account_email
      billing_email
      billing_details
      shipping_details
      time_zone
      invoice_prefix
      next_invoice
      tax_id
      inserted_dt
      updated_dt
      customer_id
      __typename
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer($updateCustomerInput: UpdateCustomerInput!) {
    updateCustomer(updateCustomerInput: $updateCustomerInput) {
      client_id
      user_id
      name
      description
      account_email
      billing_email
      billing_details
      shipping_details
      time_zone
      invoice_prefix
      next_invoice
      tax_id
      inserted_dt
      updated_dt
      customer_id
      __typename
    }
  }
`;
export const deleteUSER = /* GraphQL */ `
  mutation DeleteUSER($user_id: String!) {
    deleteUSER(user_id: $user_id) {
      client_id
      user_id
      first_name
      last_name
      email
      company_name
      country
      is_active
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const createUSER = /* GraphQL */ `
  mutation CreateUSER($createUSERInput: CreateUSERInput!) {
    createUSER(createUSERInput: $createUSERInput) {
      client_id
      user_id
      first_name
      last_name
      email
      company_name
      country
      is_active
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const updateUSER = /* GraphQL */ `
  mutation UpdateUSER($updateUSERInput: UpdateUSERInput!) {
    updateUSER(updateUSERInput: $updateUSERInput) {
      client_id
      user_id
      first_name
      last_name
      email
      company_name
      country
      is_active
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const deleteUser_profile = /* GraphQL */ `
  mutation DeleteUser_profile($user_profile_id: String!) {
    deleteUser_profile(user_profile_id: $user_profile_id) {
      user_profile_id
      client_id
      user_id
      billing_plan
      client_company_ein
      client_comapny_segement
      address
      acct_display_name
      is_admin
      __typename
    }
  }
`;
export const createUser_profile = /* GraphQL */ `
  mutation CreateUser_profile(
    $createUser_profileInput: CreateUser_profileInput!
  ) {
    createUser_profile(createUser_profileInput: $createUser_profileInput) {
      user_profile_id
      client_id
      user_id
      billing_plan
      client_company_ein
      client_comapny_segement
      address
      acct_display_name
      is_admin
      __typename
    }
  }
`;
export const updateUser_profile = /* GraphQL */ `
  mutation UpdateUser_profile(
    $updateUser_profileInput: UpdateUser_profileInput!
  ) {
    updateUser_profile(updateUser_profileInput: $updateUser_profileInput) {
      user_profile_id
      client_id
      user_id
      billing_plan
      client_company_ein
      client_comapny_segement
      address
      acct_display_name
      is_admin
      __typename
    }
  }
`;
export const deleteCoupon = /* GraphQL */ `
  mutation DeleteCoupon($coupon_id: String!) {
    deleteCoupon(coupon_id: $coupon_id) {
      coupon_id
      client_id
      user_id
      name
      coupon_type
      percentage_off
      specific_product
      duration
      redemption_limits
      codes
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const createCoupon = /* GraphQL */ `
  mutation CreateCoupon($createCouponInput: CreateCouponInput!) {
    createCoupon(createCouponInput: $createCouponInput) {
      coupon_id
      client_id
      user_id
      name
      coupon_type
      percentage_off
      specific_product
      duration
      redemption_limits
      codes
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const updateCoupon = /* GraphQL */ `
  mutation UpdateCoupon($updateCouponInput: UpdateCouponInput!) {
    updateCoupon(updateCouponInput: $updateCouponInput) {
      coupon_id
      client_id
      user_id
      name
      coupon_type
      percentage_off
      specific_product
      duration
      redemption_limits
      codes
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const deleteInvoice_Items = /* GraphQL */ `
  mutation DeleteInvoice_Items($invoice_items_id: String!) {
    deleteInvoice_Items(invoice_items_id: $invoice_items_id) {
      client_id
      user_id
      invoice_items_id
      item
      qty
      price
      supply_date
      inserted_dt
      updated_dt
      customer_id
      status
      __typename
    }
  }
`;
export const createInvoice_Items = /* GraphQL */ `
  mutation CreateInvoice_Items(
    $createInvoice_ItemsInput: CreateInvoice_ItemsInput!
  ) {
    createInvoice_Items(createInvoice_ItemsInput: $createInvoice_ItemsInput) {
      client_id
      user_id
      invoice_items_id
      item
      qty
      price
      supply_date
      inserted_dt
      updated_dt
      customer_id
      status
      __typename
    }
  }
`;
export const updateInvoice_Items = /* GraphQL */ `
  mutation UpdateInvoice_Items(
    $updateInvoice_ItemsInput: UpdateInvoice_ItemsInput!
  ) {
    updateInvoice_Items(updateInvoice_ItemsInput: $updateInvoice_ItemsInput) {
      client_id
      user_id
      invoice_items_id
      item
      qty
      price
      supply_date
      inserted_dt
      updated_dt
      customer_id
      status
      __typename
    }
  }
`;
export const deleteProduct_info = /* GraphQL */ `
  mutation DeleteProduct_info($product_id: String!) {
    deleteProduct_info(product_id: $product_id) {
      product_id
      customer_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      metadata
      feature_list
      __typename
    }
  }
`;
export const createProduct_info = /* GraphQL */ `
  mutation CreateProduct_info(
    $createProduct_infoInput: CreateProduct_infoInput!
  ) {
    createProduct_info(createProduct_infoInput: $createProduct_infoInput) {
      product_id
      customer_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      metadata
      feature_list
      __typename
    }
  }
`;
export const updateProduct_info = /* GraphQL */ `
  mutation UpdateProduct_info(
    $updateProduct_infoInput: UpdateProduct_infoInput!
  ) {
    updateProduct_info(updateProduct_infoInput: $updateProduct_infoInput) {
      product_id
      customer_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      metadata
      feature_list
      __typename
    }
  }
`;
export const deleteProductInfo = /* GraphQL */ `
  mutation DeleteProductInfo($product_id: String!) {
    deleteProductInfo(product_id: $product_id) {
      product_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      metadata
      feature_list
      __typename
    }
  }
`;
export const createProductInfo = /* GraphQL */ `
  mutation CreateProductInfo($createProductInfoInput: CreateProductInfoInput!) {
    createProductInfo(createProductInfoInput: $createProductInfoInput) {
      product_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      metadata
      feature_list
      __typename
    }
  }
`;
export const updateProductInfo = /* GraphQL */ `
  mutation UpdateProductInfo($updateProductInfoInput: UpdateProductInfoInput!) {
    updateProductInfo(updateProductInfoInput: $updateProductInfoInput) {
      product_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      metadata
      feature_list
      __typename
    }
  }
`;
export const deletePrice_info = /* GraphQL */ `
  mutation DeletePrice_info($price_id: String!) {
    deletePrice_info(price_id: $price_id) {
      price_id
      customer_id
      client_id
      user_id
      pricing_model
      price_data
      units_data
      select_currency
      billing_type
      metadata
      billing_period
      charge_metered
      price_description
      free_trial
      product_id
      __typename
    }
  }
`;
export const createPrice_info = /* GraphQL */ `
  mutation CreatePrice_info($createPrice_infoInput: CreatePrice_infoInput!) {
    createPrice_info(createPrice_infoInput: $createPrice_infoInput) {
      price_id
      customer_id
      client_id
      user_id
      pricing_model
      price_data
      units_data
      select_currency
      billing_type
      metadata
      billing_period
      charge_metered
      price_description
      free_trial
      product_id
      __typename
    }
  }
`;
export const updatePrice_info = /* GraphQL */ `
  mutation UpdatePrice_info($updatePrice_infoInput: UpdatePrice_infoInput!) {
    updatePrice_info(updatePrice_infoInput: $updatePrice_infoInput) {
      price_id
      customer_id
      client_id
      user_id
      pricing_model
      price_data
      units_data
      select_currency
      billing_type
      metadata
      billing_period
      charge_metered
      price_description
      free_trial
      product_id
      __typename
    }
  }
`;
export const deleteProductstatus = /* GraphQL */ `
  mutation DeleteProductstatus($production_id: String!) {
    deleteProductstatus(production_id: $production_id) {
      production_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      meta_data
      feature_list
      __typename
    }
  }
`;
export const createProductstatus = /* GraphQL */ `
  mutation CreateProductstatus(
    $createProductstatusInput: CreateProductstatusInput!
  ) {
    createProductstatus(createProductstatusInput: $createProductstatusInput) {
      production_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      meta_data
      feature_list
      __typename
    }
  }
`;
export const updateProductstatus = /* GraphQL */ `
  mutation UpdateProductstatus(
    $updateProductstatusInput: UpdateProductstatusInput!
  ) {
    updateProductstatus(updateProductstatusInput: $updateProductstatusInput) {
      production_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      meta_data
      feature_list
      __typename
    }
  }
`;
export const deleteUSER_EXTENSION = /* GraphQL */ `
  mutation DeleteUSER_EXTENSION($activate_payment_id: String!) {
    deleteUSER_EXTENSION(activate_payment_id: $activate_payment_id) {
      client_id
      user_id
      email
      activate_payment_id
      business_location
      type_of_business
      business_structure
      business_name
      business_indentification_number
      doing_business_as
      business_country
      business_address1
      business_address2
      business_city
      business_state
      zip
      business_phone_number
      industry
      business_website
      product_description
      representative_first_name
      representative_last_name
      representative_email
      representative_job_title
      representative_DOB
      representative_country
      representative_address1
      representative_address2
      representative_city
      representative_state
      representative_zip
      representative_phone_number
      representative_social_sequrity_number
      owner_first_name
      owner_last_name
      owner_email
      is_physical_goods
      recive_goods_services
      statement_descriptor
      shortened_descriptor
      customer_suport_phone
      customer_suport_country
      customer_suport_address1
      customer_suport_address2
      customer_suport_city
      customer_suport_state
      customer_suport_zip
      routing_number
      account_number
      confirm_account_number
      account_secure_method
      your_product_category
      __typename
    }
  }
`;
export const createUSER_EXTENSION = /* GraphQL */ `
  mutation CreateUSER_EXTENSION(
    $createUSER_EXTENSIONInput: CreateUSER_EXTENSIONInput!
  ) {
    createUSER_EXTENSION(
      createUSER_EXTENSIONInput: $createUSER_EXTENSIONInput
    ) {
      client_id
      user_id
      email
      activate_payment_id
      business_location
      type_of_business
      business_structure
      business_name
      business_indentification_number
      doing_business_as
      business_country
      business_address1
      business_address2
      business_city
      business_state
      zip
      business_phone_number
      industry
      business_website
      product_description
      representative_first_name
      representative_last_name
      representative_email
      representative_job_title
      representative_DOB
      representative_country
      representative_address1
      representative_address2
      representative_city
      representative_state
      representative_zip
      representative_phone_number
      representative_social_sequrity_number
      owner_first_name
      owner_last_name
      owner_email
      is_physical_goods
      recive_goods_services
      statement_descriptor
      shortened_descriptor
      customer_suport_phone
      customer_suport_country
      customer_suport_address1
      customer_suport_address2
      customer_suport_city
      customer_suport_state
      customer_suport_zip
      routing_number
      account_number
      confirm_account_number
      account_secure_method
      your_product_category
      __typename
    }
  }
`;
export const updateUSER_EXTENSION = /* GraphQL */ `
  mutation UpdateUSER_EXTENSION(
    $updateUSER_EXTENSIONInput: UpdateUSER_EXTENSIONInput!
  ) {
    updateUSER_EXTENSION(
      updateUSER_EXTENSIONInput: $updateUSER_EXTENSIONInput
    ) {
      client_id
      user_id
      email
      activate_payment_id
      business_location
      type_of_business
      business_structure
      business_name
      business_indentification_number
      doing_business_as
      business_country
      business_address1
      business_address2
      business_city
      business_state
      zip
      business_phone_number
      industry
      business_website
      product_description
      representative_first_name
      representative_last_name
      representative_email
      representative_job_title
      representative_DOB
      representative_country
      representative_address1
      representative_address2
      representative_city
      representative_state
      representative_zip
      representative_phone_number
      representative_social_sequrity_number
      owner_first_name
      owner_last_name
      owner_email
      is_physical_goods
      recive_goods_services
      statement_descriptor
      shortened_descriptor
      customer_suport_phone
      customer_suport_country
      customer_suport_address1
      customer_suport_address2
      customer_suport_city
      customer_suport_state
      customer_suport_zip
      routing_number
      account_number
      confirm_account_number
      account_secure_method
      your_product_category
      __typename
    }
  }
`;
export const createUserinfo = /* GraphQL */ `
  mutation CreateUserinfo(
    $input: CreateUserinfoInput!
    $condition: ModelUserinfoConditionInput
  ) {
    createUserinfo(input: $input, condition: $condition) {
      id
      fullname
      email
      phonenumber
      country_name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserinfo = /* GraphQL */ `
  mutation UpdateUserinfo(
    $input: UpdateUserinfoInput!
    $condition: ModelUserinfoConditionInput
  ) {
    updateUserinfo(input: $input, condition: $condition) {
      id
      fullname
      email
      phonenumber
      country_name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserinfo = /* GraphQL */ `
  mutation DeleteUserinfo(
    $input: DeleteUserinfoInput!
    $condition: ModelUserinfoConditionInput
  ) {
    deleteUserinfo(input: $input, condition: $condition) {
      id
      fullname
      email
      phonenumber
      country_name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createContact = /* GraphQL */ `
  mutation CreateContact(
    $input: CreateContactInput!
    $condition: ModelContactConditionInput
  ) {
    createContact(input: $input, condition: $condition) {
      id
      name
      email
      description
      billinginfo {
        id
        time_zone
        language_name
        currency_name
        invoice_prefix
        next_invoice_sequence
        tax_status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateContact = /* GraphQL */ `
  mutation UpdateContact(
    $input: UpdateContactInput!
    $condition: ModelContactConditionInput
  ) {
    updateContact(input: $input, condition: $condition) {
      id
      name
      email
      description
      billinginfo {
        id
        time_zone
        language_name
        currency_name
        invoice_prefix
        next_invoice_sequence
        tax_status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteContact = /* GraphQL */ `
  mutation DeleteContact(
    $input: DeleteContactInput!
    $condition: ModelContactConditionInput
  ) {
    deleteContact(input: $input, condition: $condition) {
      id
      name
      email
      description
      billinginfo {
        id
        time_zone
        language_name
        currency_name
        invoice_prefix
        next_invoice_sequence
        tax_status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
